window.InifECShared.factory("$InifECGA", ["$analytics", function ($analytics) {

    var _factory = {};

    var isRelease = false;

    var pageTrack = function(pageurl) {

        if(!isRelease) {
            return;
        }

        $analytics.pageTrack(pageurl);
    }

    var eventTrack = function(category, action, label, value) {
        
        if(!isRelease) {
            return;
        }

        $analytics.eventTrack(action, {
            category: category,
            label: label,
            value: value || 1,
        });        
    }

    var setMrscid = function(mrscid) {

        var value = mrscid ? mrscid : "";

        setCustomDimensions("dimension1", value);
    }

    var sendEcommerceSuccess = function(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF) {

        // 正式環境才發送商務資訊
        if(!isRelease) {
            return;
        }

        sendEcommerceGA(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF);
        sendBingAdwords(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF);
        sendGoogleAdwords(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF);
        sendOrderItemGA(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF);
        sendOrderItemFBPixel(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF);
    }

    var sendEcommerceGA = function(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF) {

        return;

        ga("ecommerce:clear");
        ga("ecommerce:addTransaction", { 
            "id": orderid,
            "affiliation": "InifEC",
            "revenue": totalSF,
            "shipping": shippingFee,
            "tax": totalSF - totalS,
            "currency": "TWD" 
        });

        for(var i = 0; i < orderitems.length; i++) {
            var item = orderitems[i];

            ga("ecommerce:addItem", { 
                "id": orderid,
                "name": item.name,
                "sku": item.productid,
                "category": item.pdtClassName,
                "price": item.price,
                "quantity": item.spec.count
            });
        }

        ga("ecommerce:send");
    }

    var sendBingAdwords = function(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF) {

        return;

        window.uetq = window.uetq || [];
        window.uetq.push({"ec": "建立訂單", "ea": "建立訂單", "el": "建立訂單", "ev": 1, "gv": totalSF });
    }

    var sendGoogleAdwords = function(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF) {

        return;

        goog_report_conversion();
    }

    var sendOrderItemGA = function(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF) {

        if(orderid) {
            eventTrack("create", { category: "order", label: orderid });
            eventTrack("create_with_mrscid", { category: "order", label: mrscid });
        }

        if(orderitems && orderitems.length) {
            for(var i = 0; i < orderitems.length; i++) {
                var item = orderitems[i];

                eventTrack("create_with_productid", { category: "order", label: item.productid });
                eventTrack("create_with_name", { category: "order", label: item.name });
                eventTrack("create_with_pdtclass", { category: "order", label: item.pdtClass });
                eventTrack("create_with_pdtclassname", { category: "order", label: item.pdtClassName });
            }
        }
    }

    var sendOrderItemFBPixel = function(mrscid, orderid, shippingFee, orderitems, total, totalS, totalSF) {

        return;

        if(fbq) {
            fbq('track', 'Purchase', {
                value: totalSF,
                currency: 'TWD',
            });
        }
    }

    var setCustomDimensions = function(dimension, value) {

        if(!isRelease) {
            return;
        }
        
        ga("set", dimension, value);
    }

    var sendFinishApplyFBPixel = function() {

        return;

        if(!isRelease) {
            return;
        }

        if(fbq) {
            fbq('track', 'CompleteRegistration');
        }
    }

    var sendAddItemToCartGA = function(ga_info, isQuickOrder) {

        if(!isQuickOrder) {
            eventTrack('product', 'add', ga_info.productid);
            eventTrack('product', 'add_with_name', ga_info.name);
            eventTrack('product', 'add_with_mrscid', ga_info.mrscid);
            eventTrack('product', 'add_with_pdtclass', ga_info.pdtclass);
            eventTrack('product', 'add_with_pdtclassname', ga_info.pdtClassName);
            eventTrack('product', 'add_with_fullinfo', JSON.stringify(ga_info));
        } else {
            eventTrack('product_quickly', 'add', ga_info.productid);
            eventTrack('product_quickly', 'add_with_name', ga_info.name);
            eventTrack('product_quickly', 'add_with_mrscid', ga_info.mrscid);
            eventTrack('product_quickly', 'add_with_pdtclass', ga_info.pdtclass);
            eventTrack('product_quickly', 'add_with_pdtclassname', ga_info.pdtClassName);
            eventTrack('product_quickly', 'add_with_fullinfo', JSON.stringify(ga_info));
        }

        sendAddItemToCartFBPixel(ga_info.productid);
    }

    var sendAddItemToCartFBPixel = function(productid) {

        return;

        if(!isRelease) {
            return;
        }
        
        if(fbq) {
            fbq('track', 'AddToCart', {
                content_ids: productid,
            });   
        }
    }

    var sendAddItemToCartGA

    var init = function() {

        isRelease = ServerID == "release";
    }

    /*==========================
        Methods
    ==========================*/
    _factory.pageTrack = pageTrack;
    _factory.eventTrack = eventTrack;
    _factory.setMrscid = setMrscid;
    _factory.sendEcommerceSuccess = sendEcommerceSuccess;
    _factory.sendFinishApplyFBPixel = sendFinishApplyFBPixel;
    _factory.sendAddItemToCartGA = sendAddItemToCartGA;

    /*==========================
        Init
    ==========================*/
    init();

    return _factory;
}]);